export default "__VITE_ASSET__7e4c5387__"